import { useMemo } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { CustomizationFlagQueries } from '@frontend/api-customization-flags';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { createNavItem, createSubNavItems } from '../nav-item-utils';

export const useReviewsNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const { selectedLocationIds } = useAppScopeStore();

  const { isFeatureHiddenInAllLocations: hideReviewsPage } =
    CustomizationFlagQueries.useAggregateCustomizationFlagDetails({
      locationIds: selectedLocationIds,
      enabled: true,
      customizationFlag: Feature.REVIEWS_HOME_ICON,
    });

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          label: t('All Reviews'),
          relativePath: '/all-reviews',
          trackingId: 'nav-reviews-all-reviews',
          description:
            'Aggregates all online reviews across multiple platforms for a unified view and easy management.',
        },
        {
          label: t('Google'),
          relativePath: '/google',
          trackingId: 'nav-reviews-google',
          description: 'Filters reviews collected specifically from Google, allowing for engagement and management.',
        },
        {
          label: t('Facebook'),
          relativePath: '/facebook',
          trackingId: 'nav-reviews-facebook',
          description: 'Displays reviews and recommendations sourced from Facebook pages associated with the practice.',
        },
        {
          label: t('Private'),
          relativePath: '/private',
          trackingId: 'nav-reviews-private',
          description: 'Confidential feedback or private reviews gathered internally, not visible on public platforms.',
        },
      ]),
    [t]
  );

  return useMemo(
    () =>
      createNavItem('reviews', {
        iconName: 'reviews-dash',
        label: t('Reviews'),
        root: '/reviews',
        subNavItems,
        settings: { path: '/reviews', label: '', show: true },
        show: !hideReviewsPage,
      }),
    [t, subNavItems, hideReviewsPage]
  );
};
